'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.default = {
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filtros}\n  =1 {um filtro}\n  ' + 'other {# filtros}\n}'
  },
  Active: 'Ativos',
  Activate: 'Ativar',
  Activated: 'Ativado',
  Add: 'Adicionar',
  add: 'adicionar',
  Alerts: 'Alertas',
  All: 'Todos',
  AxisLabel: 'Coordenada {orientation}',
  area: 'Área',
  Bar: 'Bar',
  bar: 'bar',
  Blank: 'Em branco',
  Box: 'Box',
  Carousel: 'Carrossel',
  camera: 'Câmera',
  Category: 'Categoria',
  Circle: 'Círculo',
  Chart: 'Gráfico',
  Children: 'Filho',
  Clear: 'Limpar',
  Cleared: 'Livre',
  Close: 'Fechar',
  close: 'fechar',
  'Close Menu': 'Fechar Menu',
  'command-line': 'linha de comando',
  Completed: 'Completado',
  'Connects With': 'Conecta-se com',
  created: 'Criado',
  Critical: 'Crítico',
  'Currently Active': 'Ativo Atualmente',
  'Date Selector': 'Seletor de Data',
  'Date Time Icon': 'Abrir Seleção de Data e Hora',
  Disabled: 'Desabilitado',
  Distribution: 'Distribuição',
  down: 'baixo',
  Email: 'Email',
  'Enter Select': 'Pressione enter para selecionar',
  Error: 'Erro',
  Filter: 'Filtro',
  filter: 'filtro',
  Footer: 'Rodapé',
  HotSpotsLabel: 'HotSpots: pressione setas de nevegação para interagir',
  hour: 'hora',
  'GraphValues': 'Gráfico têm {count} itens. O maior é {highest}' + ' e o menor é {smallest}',
  'Grommet Logo': 'Gromment Logomarca',
  'Layer': 'Modal',
  line: 'linha',
  'link-next': 'link-next',
  'link-previous': 'link-previous',
  'Loading': 'Carregando',
  loginInvalidPassword: 'Por favor, informe Usuário e Senha.',
  'Log In': 'Logar',
  Logout: 'Deslogar',
  'Main Content': 'Conteúdo Principal',
  Max: 'Max',
  Menu: 'Menu',
  menu: 'menu',
  Meter: 'Meter',
  Min: 'Min',
  minute: 'minuto',
  model: 'Modelo',
  modified: 'Modificado',
  monitor: 'monitor',
  more: 'mais',
  'Multi Select': 'Seleção Múltipla',
  Name: 'Nome',
  'Navigation Help': 'Use as setas para navegar',
  'Next Month': 'Próximo Mês',
  'Next Slide': 'Próximo Slide',
  'No Relationship': 'Sem Relacionamento',
  'Notification': 'Notificação',
  OK: 'OK',
  Open: 'Abrir',
  Parent: 'Pai',
  Parents: 'Pais',
  Parts: 'Partes',
  Part: 'Parte',
  Password: 'Senha',
  power: 'power',
  'Previous Month': 'Mês Anterior',
  'Previous Slide': 'Slide Anterior',
  'Previous Tiles': 'Tiles Anteriores',
  'Remember me': 'Lembrar Usuário',
  Resource: 'Recurso',
  Running: 'Executando',
  Search: 'Buscar',
  search: 'buscar',
  'Match Results': '{count, plural,\n      =0 {N\xE3o existe sugest\xE3o}\n      one {Existe # sugest\xE3o}\n      other {Existem # sugest\xF5es}\n  }',
  second: 'segundo',
  'Select Icon': 'Abrir menu de seleção',
  Selected: 'Selecionada(o)',
  'Skip to': 'Saltar para',
  'Slide Number': 'Slide {slideNumber}',
  Spinning: 'Carregando',
  State: 'Estado',
  Status: 'Situaçāo',
  SubBurst: 'SubBurst',
  Subtract: 'Subtrair',
  subtract: 'subtrair',
  'Tab Contents': '{activeTitle} Conteúdo da Tab',
  Table: 'Tabela',
  Tasks: 'Tarefas',
  Tiles: 'Tiles',
  Time: 'Data',
  Title: 'Título',
  Today: 'Hoje',
  Topology: 'Topologia',
  Total: 'Total',
  trash: 'lixeira',
  Threshold: 'Limiar',
  Unknown: 'Desconhecido',
  user: 'user',
  Username: 'Usuário',
  uri: 'URI',
  validation: 'validation',
  Value: 'Valor',
  Warning: 'Alerta'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/pt-BR.js
// module id = 132
// module chunks = 0